/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { groupBy, keyBy, keys, mapValues } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    allProducts: [],
    byId: {},
}

const ProductsSlice = createAppSlice({
    name: 'products',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createProduct: create.asyncThunk(
            async (product, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.product(), { body: product, method: 'POST' })
                    toast.success('Produit créé')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'un produit')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        updateProduct: create.asyncThunk(
            async (product, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.product(), { body: product, method: 'PUT' })
                    toast.success('Produit mis à jour')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la mise à jour d\'un produit')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        deleteProduct: create.asyncThunk(
            async ({ id }, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.product(id), { method: 'DELETE' })
                    toast.success('Produit supprimé')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'un produit')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetchProducts: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.commercialFeatures.product())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des produits')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.byId = keyBy(action.payload, 'id')
                    state.allProducts = action.payload
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.products.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
    }),
})

export const { fetchProducts, createProduct, updateProduct, deleteProduct } = ProductsSlice.actions
export default ProductsSlice